module.exports = __webpack_public_path__ + "44c309f11.png";